import { render, staticRenderFns } from "./DolarIcon.vue?vue&type=template&id=4c1bae42&scoped=true&"
var script = {}
import style0 from "./DolarIcon.vue?vue&type=style&index=0&id=4c1bae42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1bae42",
  null
  
)

export default component.exports